import { To } from "react-router";
import { localizePath } from "../../utils/language";

export const localizeTo = (to: To, lang: string): To => {
  if (typeof to === "string") {
    return localizePath(to, lang);
  }
  if (to.pathname) {
    return { ...to, pathname: localizePath(to.pathname, lang) };
  }
  return to;
};

const plRootHost = "premierleague.com";

export const isPLLink = (url: string): boolean => {
  try {
    const hostname = new URL(url).hostname.toLowerCase();
    return hostname === plRootHost || hostname.endsWith(`.${plRootHost}`);
  } catch {
    return false;
  }
};
